import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import LeftInput from "./components/LeftInput";
import RightInput from "./components/RightInput";
import { showApplication } from "../../../../redux/applicationSettings/applicationAction";
import { filterPublicShippers } from "../../../../redux/publicShippers/publicShippersActions";

export default function CreateRestaurantOrder() {
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);

  let [recipient_phone, setRecipientPhone] = useState("");

  // console.log("recipient_phone", recipient_phone);
  const [data, setData] = useState({
    business_id: "",
    user_address_id: "",
    user_id: "",
    restaurant_id: "",
    recipient_name: "",
    recipient_email: "",
    recipient_phone: "",
    recipient_address: "",
    recipient_city: "",
    recipient_state: "",
    recipient_country: "",
    recipient_invoice: "mail",
    order_type: "standard",
    order_items: [],
    order_amount: "",
    order_discount: 0,
    recipient_service_area_id: "",
    recipient_location_latitude: "",
    recipient_location_longitude: "",
    shipper_id: "",
  });
  useEffect(() => {
    dispatch(showApplication());
    // Fetch shippers for both logged-in and guest users
    dispatch(
      filterPublicShippers({
        date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        pagination: 0,
      })
    );
    // eslint-disable-next-line
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };
  return (
    <div data-test="createOrder-page">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] md:h-[786px] rounded-md py-5 px-8">
          <LeftInput
            handleChange={handleChange}
            data={data}
            setData={setData}
            submitted={submitted}
            recipient_phone={recipient_phone}
            setRecipientPhone={setRecipientPhone}
          />
        </div>

        <RightInput
          data={data}
          setData={setData}
          submitted={submitted}
          setSubmitted={setSubmitted}
          handleChange={handleChange}
          recipient_phone={recipient_phone}
        />
      </div>
    </div>
  );
}
